/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [入库来源信息↗](http://yapi.yishou.com/project/128/interface/api/29875) 的 **请求配置**
 *
 * @分类 [前端公共↗](http://yapi.yishou.com/project/128/interface/api/cat_2274)
 * @请求头 `POST /erp/Common/selectStockSource`
 * @更新时间 `2021-09-08 18:27:16`
 */
const selectStockSourceRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Common/selectStockSource",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: { type: "object", required: [], properties: {} },
  responseDataJsonSchema: {
    type: "array",
    items: {
      type: "object",
      properties: {
        label: { type: "number", description: "入库来源编号" },
        value: { type: "string", description: "入库来源编号对应的名称" },
      },
      required: ["label", "value"],
    },
  },
  requestFunctionName: "selectStockSource",
  extraInfo: {},
};
/**
 * 接口 [入库来源信息↗](http://yapi.yishou.com/project/128/interface/api/29875) 的 **请求函数**
 *
 * @分类 [前端公共↗](http://yapi.yishou.com/project/128/interface/api/cat_2274)
 * @请求头 `POST /erp/Common/selectStockSource`
 * @更新时间 `2021-09-08 18:27:16`
 */
export const selectStockSource = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(selectStockSourceRequestConfig, requestData), ...args);
};
selectStockSource.requestConfig = selectStockSourceRequestConfig;
/**
 * 接口 [获取obs 上传信息↗](http://yapi.yishou.com/project/128/interface/api/33298) 的 **请求配置**
 *
 * @分类 [前端公共↗](http://yapi.yishou.com/project/128/interface/api/cat_2274)
 * @请求头 `GET /open/Merchants/getObsUploadData`
 * @更新时间 `2022-03-24 09:28:34`
 */
const getObsUploadDataRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/open/Merchants/getObsUploadData",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {
    type: "object",
    properties: {
      uptoken: {
        type: "object",
        properties: {
          access_key_id: { type: "string" },
          policy: { type: "string" },
          signature: { type: "string" },
          success_action_status: { type: "number" },
          domain: { type: "string" },
        },
      },
      path: { type: "string" },
      bucket_name: { type: "string" },
      endpoint: { type: "string" },
    },
  },
  requestFunctionName: "getObsUploadData",
  extraInfo: {},
};
/**
 * 接口 [获取obs 上传信息↗](http://yapi.yishou.com/project/128/interface/api/33298) 的 **请求函数**
 *
 * @分类 [前端公共↗](http://yapi.yishou.com/project/128/interface/api/cat_2274)
 * @请求头 `GET /open/Merchants/getObsUploadData`
 * @更新时间 `2022-03-24 09:28:34`
 */
export const getObsUploadData = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getObsUploadDataRequestConfig, requestData), ...args);
};
getObsUploadData.requestConfig = getObsUploadDataRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/frontCommon.js